/*
 * Copyright 2026 Sony Corporation
 */
import type { Usage } from '@ips-jit/schema';
import { createContext, useContext } from 'react';

export interface UsageContextValue {
  /** Undefined until the first answer, and while the usage cannot be read. */
  usage: Usage | undefined;
  /** Reads the usage again, e.g. after a request to the assistant. */
  refresh: () => void;
}

export const UsageContext = createContext<UsageContextValue | undefined>(undefined);

/** The signed-in user's usage, or undefined outside the app shell (in page tests, for one). */
export const useUsage = (): UsageContextValue | undefined => useContext(UsageContext);
